"use strict";
export function feature_js_focus_onload(el) {
    var text = el;
    if (!el.is(':input')) {
        text = el.find(':input').filter(function () { return !this.value; });
        if (!text.length) text = el.find(':input');
    }
    $(text[0]).focus();
}